<template>
    <div class="page" :style="{ height: fixedHeight + 'px' }">
      <div class="flex">
        <div class="m-r-10">输入查询</div>
        <el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
					clearable size="small" @keyup.enter.native="handelSearchClick"/>
        <div class="m-r-10">角色状态</div>
        <el-select v-model="state" placeholder="请选择" class="titleSelect" @change="handelSearchClick" size="small">
          <el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <!-- 表格 -->
      <div class="tableView">
        <div class="flex">
          <div class="m-r-10">数据列表</div>
          <el-button  class="addClick" @click="handleResetClick" size="small">新增角色</el-button>
        </div>
        <el-table :data="RoleList" style="width: 100%;">
				<el-table-column prop="title" label="角色名称">
				</el-table-column>
				<el-table-column prop="" label="角色人数">
          <!-- <el-tooltip class="item" effect="dark" :content="11" placement="right">
					<i class="el-icon-view" style="color:#F5882A;margin-left: 4px;"></i>
					</el-tooltip> -->
          <template slot-scope="scope"> 
          <el-button  icon="el-icon-view"  type="text" @click="handleSeeNum(scope.row)" size="small"></el-button>
        </template>
        </el-table-column>
			
				<el-table-column prop="remark" label="角色介绍">
				</el-table-column>
        <el-table-column prop="" label="角色状态">
          <template slot-scope="scope"> 
          <el-switch  v-model="scope.row.is_enable" @change="isEnable(scope.row.id)"  active-color="#13ce66" :active-value="1"  :inactive-value="0"  inactive-color="#ff4949">
        </el-switch> 
      </template>
				</el-table-column>
				<el-table-column label="操作" width="300px">
          <template slot-scope="scope">
          <el-button class="addClick" @click="handleUpdate(scope.row)" size="small">编辑</el-button>
          <el-button  class="addClick" @click="handleAdd(scope.row)" size="small">分配权限</el-button>
          <el-button  class="addClick" @click="handleDel(scope.row)" size="small">删除</el-button>
        </template>
				</el-table-column>
			</el-table>
      </div>
      <!--新建一级菜单 -->
      <el-dialog title="新增角色" :visible.sync="dialogResetStates" width="40%" :before-close="handleTypeClose">
        <div class="dialogContent">
            <div>角色名称:</div>
            <el-input v-model="title" placeholder="请输入" size="small" class="input"></el-input>
          </div>
          <div class="dialogContent">
          <div>描述说明:</div>
         <el-input type="textarea" v-model="remark"></el-input>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogResetStates = false" size="small">取 消</el-button>
          <el-button type="warning" @click="handleSubmitReset" size="small">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="编辑" :visible.sync="dialogUpdateStates" width="40%"  :close-on-click-modal="false"  v-if="dialogUpdateStates">
       
          <div class="dialogContent">
            <div>角色名称:</div>
            <el-input v-model="UpdateRole.title" placeholder="请输入" size="small" class="input"></el-input>
          </div>
          <div class="dialogContent">
          <div>描述说明:</div>
         <el-input type="textarea" v-model="UpdateRole.remark"></el-input>
          </div>
    
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogUpdateStates= false" size="small">取 消</el-button>
          <el-button type="warning" @click="handleSubmitUpdate" size="small">确定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="员工" :visible.sync="dialogStaffStates" width="40%">
        <div class="dialogContent" v-if="RoleStaff">
           <div v-for="(item,index) in RoleStaff" :key="index">{{item.name}}</div>
          </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogStaffStates = false" size="small">取 消</el-button>
          <el-button type="warning" @click="handleSubmitStaff" size="small">确定</el-button>
        </span>
      </el-dialog>
      <div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
  
    </div>
  </template>
    
  <script>
  import page from "@/components/page.vue";
  export default {
    components: {
    page
  },
    data() {
      return {
        keyword:'',
      	page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
        state:-1,  //状态
        states: [{ label: '全部', value: -1 },{ label: '启用', value: 1 }, { label: '未启用', value: 0 }],  //状态列表
        remark:'',//描述说明
        title: '',
        fixedHeight: '',
      
        RoleList:[],//角色列表
        dialogResetStates: false, //新建一级菜单 弹框
        dialogUpdateStates: false, //编辑一级菜单 弹框
        dialogStaffStates:false, //查看员工
        // 编辑
       UpdateRole:{
        title: '',
        remark:'',//描述说明

       },
       RoleStaff:[]
      }
    },
    mounted() {
      this.getRoleList()
      this.fixedHeight = document.documentElement.clientHeight - 76;
    },
    methods: {
      // 角色列表
      getRoleList() {
      let params = {
        keyword: this.keyword,
        state:this.state,
        "pageIndex": this.page.page,
				"pageSize": this.page.pageSize,
      }
      this.$http.get(process.env.VUE_APP_zichan + '/api/SystemRights/role/list', params).then(res => {
        if (res.code == 0) {
         this.RoleList=res.data.list;
         this.page.total = res.data.count;

        }
      })
    },
    // 角色状态
    isEnable(e){
      let params={
        id:e
      }
      this.$http.get(process.env.VUE_APP_zichan + '/api/SystemRights/role/changeState', params).then(res => {
        if (res.code == 0&&res.data==true) {
          this.$message({
            type: 'success',
            message: '已更改状态'
          })
          this.getRoleList()
        }else{
          this.getRoleList()
        }
      })
    },
    // 角色人数查看 
    handleSeeNum(row){
      this.dialogStaffStates = true;
      let params = {
        roleId: row.id,
      };
      this.$http
        .get(process.env.VUE_APP_zichan + "/api/SystemRights/role/staffs", params)
        .then((res) => {
          if (res.code == 0) {
            this.RoleStaff = res.data;
          }
        });
    },
    handleSubmitStaff(){
     this.dialogStaffStates = false;
    },
    // 列表
			changePage(num) {
				this.page.page = num;
				this.getRoleList()
			},
      handelSearchClick() {
        this.page.page = 1;
        this.getRoleList()
      },
      // 新增一级菜单
      handleResetClick() {
        this.dialogResetStates = true;
      },
      // 确定按钮关闭 新建一级菜单弹框
      handleSubmitReset() {
        let params={
          title: this.title,
           remark:this.remark,
        }
        this.$http.post(process.env.VUE_APP_zichan + '/api/SystemRights/role/add', params).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '已新增'
          })
          this.title=''
          this.remark=''
          this.getRoleList()
        }
      })
        this.dialogResetStates = false;
      },
      // 叉号关闭
      handleTypeClose() {
        this.dialogResetStates = false;
      },
      // 编辑
      handleUpdate(row) {
         this.UpdateRole=JSON.parse(JSON.stringify(row))
        this.dialogUpdateStates=true
      },
      handleUpdateClose(){
        this.dialogUpdateStates=false
      },
      // 确定按钮关闭 编辑角色弹框
      handleSubmitUpdate(){
        let params={
          title: this.UpdateRole.title,
           remark:this.UpdateRole.remark,
           id:this.UpdateRole.id
        }
        this.$http.post(process.env.VUE_APP_zichan + '/api/SystemRights/role/update', params).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '已修改'
          })
          this.getRoleList()
        }
      })
        this.dialogUpdateStates=false
      },
      //查看
      handleAdd(row) {
        this.$router.push({ path: 'AllotRole',query:{
					id:row.id,
          title:row.title
				} })
      },
      // 删除
      handleDel(row) {
        this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params={
           id:row.id
        }
        this.$http.delete(process.env.VUE_APP_zichan + '/api/SystemRights/role/delete', params).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '已删除'
          })
          this.getRoleList()
        }
      })
    })
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  .page {
    display: flex;
    flex-direction: column;
  
    .flex {
      background-color: #fff;
      display: flex;
      align-items: center;
      padding: 15px 10px;
    }
    .titleInput {
		width: 130px;
		}
    .m-r-10 {
      margin-right: 10px;
      font-size: 12px;
    }
  
    .tableView {
      .flex {
        background-color: #fff;
        margin: 5px 0 0 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 10px;
      }
  
      .addClick {
        color: #fff;
        background-color: #F5882A;
      }
  
      .m-r-10 {
        margin-right: 10px;
        font-size: 12px;
      }
    }
  
    .dialogContent {
      .input{
        width: 250px;
      }
      div {
        padding: 5px 10px;
      }
    }
  
    .dialogFlex {
  
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 40px;
    }
  }</style>